import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Permission, Res, SalesOrderDTO } from 'core/api';
import * as SalesStore from 'pos/modules/main/SalesStore';
import { Command } from 'pos/common';
import { Message } from 'core/ui-next/modal';


declare global {
	interface CommandType {
		prepareCurrentTicket: () => Promise<Result>,
		prepareSalesOrder: (order: SalesOrderDTO) => Promise<Result>
		prepareMultipleTickets: (ticketIds: number[]) => Promise<Result>
	}
}

Command.register('prepareMultipleTickets', Preconditions.ensure(Permission.Ticket_PrepareTicket), async (ticketIds: number[]) => {
	return prepareTickets(ticketIds);
});

Command.register('prepareCurrentTicket', Preconditions.ensure(Permission.Ticket_PrepareTicket), async () => {
	const ticket = SalesStore.getTicket();

	if (ticket.IsEmpty) {
		await Message.show(Res.Msg.MSG_TICKET_IS_EMPTY());
		return Result.error();
	}

	return prepareTickets([ticket.Id]);
});

Command.register('prepareSalesOrder', Preconditions.ensure(Permission.Ticket_PrepareTicket), async (order: SalesOrderDTO) => {
	return prepareTickets([order.TicketId]);
});

async function prepareTickets(ticketIds: number[]): Promise<Result> {

	// Paso por el SalesStore en lugar de usar directamente la fachada porque alguno de los tickets
	// preparados podría estar cargado en la pantalla principal, y habría que controlar errores
	// de concurrencia y lanzar los eventos adecuados en ese caso.

	await SalesStore.prepare(ticketIds);
	return Result.ok();
}